
    export default {
        name: "HappyKidsHeroMobileSection",
        props: {
            anchorLink: {
                type: String,
                default: '#'
            },
            data: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                protectionLists: [
                    { title: 'dfdfdf'},
                    { title: 'dfdfdf'},
                    { title: 'dfdfdf'},
                    { title: 'dfdfdf'},
                    { title: 'dfdfdf'},
                ],
                isActive: false
            }
        },
        computed: {
            backgroundSrc() {
                return  {backgroundImage: `url(${this.data?.mobileBackgroundImage?.url})`}
            },
            rightImageScr() {
                return this.data?.mobileHeadImage?.url;
            },
            subtitleBackgroundColor() {
                if (this.$route.params.productCat == 'young-kids') {
                    return {backgroundColor: "#FFBA4E"}
                }
                return {backgroundColor:"#FF7E7E"}
            },
            showSubcategory() {
                if (this.$route.params.any){
                    return this.$route.params.any.includes('before-birth') ? false : true;
                }
                if (this.$route.params.productCat !== 'before-birth') {
                    return true;
                }
                return false;
            }
        },
        methods: {
            clickToSelect() {
                this.isActive = !this.isActive;
            },
            iconSrc(icon) {
                return require(`@/assets/images/family/icon/${icon}.svg`)
            }
        },
    }
